<!--
 * @Author: your name
 * @Date: 2021-04-20 11:57:04
 * @LastEditTime: 2021-04-21 14:12:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\aftermarket/selectType.vue
-->
<template>
  <div class="markfg">
    <div class="order_goods">
      <img :src="imgPath+'yi_bg_order.png'" alt />
      <div>
        <p>商品名称标题最商品名称标题最多显示示示示示示示一多显示示示示示示示一</p>
        <b>白色/wiff版本*1</b>
        <span>
          <i>￥</i> 129.00
        </span>
      </div>
    </div>

    <ul class="seltype">
      <li>
        <p>退货</p>
        <img :src="imgPath+'yj_arrow.png'" alt />
      </li>
      <li>
        <p>换货</p>
        <img :src="imgPath+'yj_arrow.png'" alt />
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
export default {
  name: 'aftermarketList',
  data() {
    return {}
  },
  created() {
    Toast('提示内容')
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.markfg {
  background: #f8f8f8;
  min-height: 100vh;
  .seltype {
    width: 710px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 14px;
    li {
      border-bottom: 1px solid #eee;
      line-height: 88px;
      height: 88px;
      font-size: 28px;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      img {
        width: 36px;
        height: 36px;
        margin-top: 22px;
      }
      &:nth-child(2) {
        border-bottom: none;
      }
    }
  }
  .order_goods {
    width: 710px;
    height: 188px;
    background: #ffffff;
    border-radius: 14px;
    margin: 0px auto;
    border-top: 20px solid #f8f8f8;
    img {
      float: left;
      width: 140px;
      height: 140px;
      border-radius: 10px;
      margin: 24px;
    }
    div {
      width: 476px;
      margin-top: 24px;
      float: left;
      p {
        width: 476px;
        font-size: 28px;
        color: #333333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 10px;
      }
      b {
        font-size: 24px;
        color: #999;
        padding: 4px 10px;
        background: #f2f2f2;
        border-radius: 8px;
        display: inline-block;
        margin-bottom: 10px;
      }
      span {
        display: block;
        color: #f0240e;
        font-size: 34px;
        i {
          font-size: 28px;
        }
      }
    }
    .apply {
      position: absolute;
      right: 20px;
      bottom: 20px;
      width: 158px;
      height: 54px;
      line-height: 54px;
      text-align: center;
      font-size: 26px;
      background: #ffffff;
      border-radius: 200px;
      border: 2px solid #dcdee0;
    }
  }
}
</style>